import { useEffect, useState } from "react"

import { toast } from "react-toastify"
import { finalize } from "rxjs/operators"

import NotificationOptions from "./NotificationOptions"
import NotificationOptionsData from "../../../api/Notifications/Model/NotificationOptionsData"
import NotificationSectionProps from "../../../api/Notifications/Model/NotificationSectionProps"
import { NotificationMethodsGet } from "../../../api/Notifications/NotificationDetailGet"
import FormatError from "../../../formatters/FormatError"

function NotificationMethodSelection(props: NotificationSectionProps) {
  const { selectedIDs, onChange } = props

  const [loading, setLoading] = useState(false)
  const [notificationMethods, setNotificationMethods] = useState<NotificationOptionsData[]>([])

  useEffect(() => {
    setLoading(true)
    const subscription = NotificationMethodsGet()
      .pipe(finalize(() => setLoading(false)))
      .subscribe(
        (data) => {
          setNotificationMethods(
            data.map((method) => ({
              Id: method.NotificationMethodID,
              Code: method.Code,
              Description: method.Description,
            }))
          )
        },
        (error) => toast.error(FormatError(error))
      )
    return () => subscription?.unsubscribe()
  }, [])

  return (
    <NotificationOptions
      items={notificationMethods}
      selectedIDs={selectedIDs}
      loading={loading}
      onChange={onChange}
      description="How would you like to be notified?"
    />
  )
}

export default NotificationMethodSelection
